// shared-lib/cabinet-runs/cornerUnit.js
//
// THE reader for which wall ids a corner unit's legs stand on. A generated
// corner unit carries `cabinetWallRefs` and NO `parentWallIds` (fromPhaseB
// strips them) — reading only parentWallIds made the corner carry-forward,
// the corner-join gate, and the Unit-scope corner override each silently
// miss every generated corner (audit F2; three drifting copies unified per
// #1527). Dependency-free so kitchen-assembly can require it without a cycle.

// A corner unit's legs stand on real walls and on PENINSULA arms — a floating-U's
// wall-to-back vertex, or its two arms' shared corner, gets the same L the
// generator builds at a room corner, and the run that turns there is one run
// (2026-09-12 single-run plan, stage 2). Islands stay out: they are built and
// edited on `buildIsland*`, never as a run leg.
const LEG_KINDS = new Set(['real', 'peninsula']);

function cornerUnitWallIds(unit) {
  if (unit?.parentWallIds?.length) return unit.parentWallIds;
  return (unit?.cabinetWallRefs || [])
    .filter((ref) => ref && LEG_KINDS.has(ref.kind) && ref.id)
    .map((ref) => ref.id);
}

module.exports = { cornerUnitWallIds };
